import { IpNames } from "../../../interfaces/interfaces";

export const directConnectIps = new Set([IpNames.shopify]);

export const accountSelectIps = new Set([
  IpNames.googleAds,
  IpNames.googleAnalytics,
  IpNames.metaAds,
  IpNames.amazonAds,
]);
